import { GridToolbarColumnsButton, GridToolbarContainer } from '@mui/x-data-grid';
import React from 'react';
import { useSelector } from 'react-redux';
import GridToolbarExportButton from './GridToolbarExportButton';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useInstantSearchDataGridContext } from '.';
import DataGridColumnReorderButton from '@/components/table/DataGridComponents/DataGridColumnReorderButton';

const InstantSearchDataGridToolbar = () => {
	const { enableExport, enableColumnReorder, objectType } = useInstantSearchDataGridContext();
  
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
  
	const requiresPrincipleUser = objectType === 'client' || objectType === 'deal';
	const showExport =
		enableExport && (!requiresPrincipleUser || userDetails?.principleUser === true);
  
	return (
		<GridToolbarContainer sx={{ px: 1 }}>
			{enableColumnReorder ? <DataGridColumnReorderButton /> : <GridToolbarColumnsButton />}
			{showExport && <GridToolbarExportButton />}
		</GridToolbarContainer>
	);
};

InstantSearchDataGridToolbar.displayName = 'InstantSearchDataGridToolbar';

export default InstantSearchDataGridToolbar;
